import { zExt } from "@redotech/redo-model/common/zod-util";
import { packingSlipSchema } from "@redotech/redo-model/packing-slips/packing-slip-definition";
import { z } from "zod";

export const getPackingSlipTemplatesByTeam = {
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(packingSlipSchema),
};
